import { otherDataAC } from "../../store/action-creators";
import store from "../../store/store";

interface ThemeProperty {
  property: string;
  dark: string;
  light: string;
}

const ThemeProperties: ThemeProperty[] = [
  {
    property: "--primary-bg-clr",
    dark: "#12101A",
    light: "#FFFFFF",
  },
  {
    property: "--secondary-bg-clr",
    dark: "#2A2831",
    light: "#FFFFFF",
  },
  {
    property: "--primary-text-clr",
    dark: "#FFFFFF",
    light: "#000000",
  },
  {
    property: "--secondary-text-clr",
    dark: "#F8F8F866",
    light: "#667085",
  },
  {
    property: "--table-hightlight-clr",
    dark: "#5454FB",
    light: "#f9fafb",
  },
  {
    property: "--primary-outline-clr",
    dark: "rgba(255, 255, 255, 0.06)",
    light: "rgba(0, 0, 0, 0.06)",
  },
  {
    property: "--primary-btn-clr",
    dark: "#414048",
    light: "#ffffff",
  },
];

export const themeChanger = (theme: string): void => {
  store.dispatch(otherDataAC.setOtherData({ theme: theme }));
  ThemeProperties.forEach((property) => {
    document.documentElement.style.setProperty(
      property.property,
      theme === "dark" ? property.dark : property.light
    );
  });
};
